<template>
    <div>
        <template v-if="crud_employee === true && crud_employee !==null">
            <form id="employeeForm" @submit.prevent="addEmployeeTimeoffDetail">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left"> Add Employee </h1>
                    <button :disabled="form.busy" class="btn btn-primary float-right submit_form">Next</button>
                    <router-link to="/employees" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                </div>
                <div class="peopple-managment-main">
                    <ul class="page-status">
                        <li class="page-status-list done">
                            <span class="status-highlighter">1</span>
                            Personal Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">2</span>
                            Job Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">3</span>
                            Tax Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">4</span>
                            Payment Details
                        </li>
                        <li class="page-status-list active">
                            <span class="status-highlighter">5</span>
                            Time Off
                            <input type="radio" name="btn" value="1">
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">6</span>
                            User Permission
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">7</span>
                            Welcome Options
                        </li>
                    </ul>
                    <div class="people-management-inner-content p-5">
                        <div class="row">
                            <div class="col-md-6 offset-md-3" v-if="myLeaveQuota && myLeaveQuota.length > 0">
                                <div class="" v-for="(mlq) in myLeaveQuota" :key="mlq.id">
                                    <label class="label block-label"> Apply {{mlq.title}} off Policy <span class="highlight-color"> {{mlq.total}} days Allowed </span> </label>
                                    <label class="radio-holder">
                                        Yes
                                        <input type="radio" :name="`casual_time_off[${mlq.id}]`" :value="form.casual_time_off[mlq.id] == 1 ? 1:'' " v-on:change="radioChange(mlq.id,1)" v-model="form.casual_time_off[mlq.id]" :class="{ 'is-invalid': form.errors.has('casual_time_off') }"/>
                                        <span class="checkmark"></span>
                                    </label> 
                                    <label class="radio-holder">
                                        No
                                        <input type="radio" :name="`casual_time_off[${mlq.id}]`" :value="form.casual_time_off[mlq.id] == 0 ? 1:'' " v-on:change="radioChange(mlq.id,0)" v-model="form.casual_time_off[mlq.id]" :class="{ 'is-invalid': form.errors.has('casual_time_off') }"/>
                                        <span class="checkmark"></span>
                                    </label>
                                    <has-error :form="form" field="casual_time_off"></has-error>
                                    <input type="number" placeholder="Balance" class="form-control balance" :name="`balance[${mlq.id}]`" autocomplete="off" v-model="form.balance[mlq.id]" min="0" :max="parseInt(mlq.total)" id="balance" :class="{ 'is-invalid': form.errors.has('balance') }"/>
                                    <has-error :form="form" field="balance"></has-error>
                                </div>
                            </div>
                            <div class="time-off-policy-box" v-else>
                                <h2><span> No Leave policy for</span><b> {{userObj.name}} [{{userObj.employment_status}}] </b></h2>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="crud_employee === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_employee === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    casual_time_off : [],
                    balance : []

                }),
                myLeaveQuota: {},
                userObj : {},
                crud_employee: null
            }
        },
        methods: {
            radioChange(key,value){
                this.form.casual_time_off[key] = value;
            },

            addEmployeeTimeoffDetail() {
                this.$Progress.start();
                this.form.post('/api/addEmployeeTimeoff/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Employee time off details added successfully'
                        });
                        this.$router.push('/addEmployeeUserPermission/'+this.$route.params.id);
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Some problem in your form data'
                        });
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            },
            getTimeOffDetail(){
                this.$Progress.start();
                axios.get('/api/getTimeoffDetail/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.page_view == false){
                            this.crud_employee = false;
                        }else if(res.data.page_view == true){
                            let that = this;
                            this.userObj = res.data.user;
                            this.myLeaveQuota = res.data.myLeaveQuota;
                            var obj =res.data.myLeaveQuota;

                            _.forEach(obj, function(e, i){
                                var key = e.id;
                                var value = e.balance;
                                that.form.balance[key] = value;
                                that.form.casual_time_off[key] = 1;
                            });
                            
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error', 'Some problem in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error', 'Some problem in your form data');
                });
            },
            getEmployeeData() {
                axios.get('/api/editEmployeeTimeOff/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.page_view == false){
                            this.crud_employee = false;
                        }else if(res.data.page_view == true){
                            if(res.data.user.wizard_cycle == 0){
                                this.$router.push('/addEmployeePersonalDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 1){
                                this.$router.push('/addEmployeeBasicDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 2){
                                this.$router.push('/addEmployeeTaxDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 3){
                                this.$router.push('/addEmployeePaymentDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 4){
                                this.getTimeOffDetail();
                            }else if(res.data.user.wizard_cycle == 5){
                                this.$router.push('/addEmployeeUserPermission/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 6){
                                this.$router.push('/addEmployeeWelcome/'+this.$route.params.id);
                            }
                        }
                    }else{
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .catch(err => {
                    this.showAlertBox('error','Error to load data');
                });
            },
        },

        mounted() {
            this.$Progress.start();
            this.can('crud_employee').then(result => {
                this.crud_employee = result.crud_employee;
            }).then(result => {
                if(this.crud_employee == true){
                    this.getEmployeeData();
                    this.$Progress.finish();
                }
            });
        }
    }
</script>
